import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { editPartnerHierarchy } from 'actions/partnerHierarchyForm'
import PartnerHierarchyDisplayForm from 'views/PartnerHierarchy/PartnerHierarchyDisplayForm'

class PartnerHierarchyForm extends Component {
  static propTypes = {
    currentUserId: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
  }

  static defaultProps = {
    id: 'partnerHierarchyForm',
  }

  _submit = (data) => {
    this.props.dispatch(editPartnerHierarchy(data, this.props.currentUserId, this.props.id))
  }

  render() {
    const {
      modals, hide, forms, id, metaData, partnerHierarchy, currentUserId,
    } = this.props
    return (
      <PartnerHierarchyDisplayForm
        currentUserId={currentUserId}
        description=""
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        metaData={metaData}
        modals={modals}
        partnerHierarchy={partnerHierarchy}
        title="Edit Partner hierarchy"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
// EDIT BELOW
const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  metaData: state.mdm,
  partnerHierarchy: state.partnerHierarchy,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerHierarchyForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerHierarchyForm.js